import type { BuiltSource } from '@velasca/types'
import { setQueryParams } from './setQueryParams'

// Remember to update the sizes in the followong .liquid snippets: srcset.liquid, srcset_file.liquid, srcset_asset.liquid
const defaultSizes = [350, 500, 650, 800, 1000, 1200, 1400, 1800, 2600, 3000]

interface BuildIntrinsicWidthSourcesProps {
  /**
   * The original image URL.
   */
  src: string

  /**
   * The maximum width of the original image.
   */
  maxWidth?: number

  /**
   * An array of sizes to build the sources for.
   */
  sizes?: number[]
}

/**
 * It takes a URL and a list of sizes, and returns a list of URLs with the width query parameter set to each of the sizes.
 */
export const buildIntrinsicWidthSources = ({
  src,
  maxWidth,
  sizes = defaultSizes,
}: BuildIntrinsicWidthSourcesProps): BuiltSource[] => {
  if (!src) {
    return []
  }

  let sources: BuiltSource[] = []

  sizes.forEach((size) => {
    if (maxWidth && maxWidth <= size) {
      return
    }

    const imageUrl = setQueryParams(src, [
      { name: 'width', value: size.toString() },
    ])

    sources = [
      ...sources,
      {
        src: imageUrl,
        width: `${size.toString()}w`,
      },
    ]
  })

  if (maxWidth) {
    sources = [
      ...sources,
      {
        src: setQueryParams(src, [
          { name: 'width', value: maxWidth.toString() },
        ]),
        width: `${maxWidth.toString()}w`,
      },
    ]
  }

  return sources
}
